import React, { useState } from 'react';
import FilterBar from '../Common/FilterBar';

const LedgerFilterBar = ({handleExport, filter}) => {
    const [openingDate, setOpeningDate] = useState('');
    const [closingDate, setClosingDate] = useState('');

    const handleFilter = () => {
        filter({ opening_date: openingDate, closing_date: closingDate });
    };

    return (
    <FilterBar
      title="Ledger listing"
      subtitle="Manage and export your ledger records"
        //   iconClass="fa fa-receipt"
      controls={[
        {
          type: "dateRange",
          fromValue: openingDate,
          toValue: closingDate,
          onChangeFrom: (e) =>setOpeningDate(e.target.value),
          onChangeTo: (e) => setClosingDate(e.target.value),
        },
      ]}
      actions={[
        { label: "Export", iconClass: "fa fa-file-excel text-primary", onClick: handleExport, variant: "secondary" },
        { label: "Apply", iconClass: "fa fa-filter", onClick: handleFilter, variant: "primary" },
      ]}
    />
    );
};

export default LedgerFilterBar;